// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMarkdown from 'vue-markdown'
import VueLineClamp from 'vue-line-clamp'


Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.component('vue-markdown', VueMarkdown)
Vue.use(VueLineClamp, {})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js